<template>
  <div class="num_box">
    <div class="input_btn">
      <input 
        ref="authInput"
        :value="value"
        @input="onInput"
        @keyup.enter="$emit('enter')"
        type="tel" 
        inputmode="numeric" 
        autocomplete="one-time-code" 
        pattern="[0-9]*"
        placeholder="인증번호 6자리" 
        maxlength="6"
        class="auth-input"
        :readonly="isTimerExpired"
      />
      <button 
        class="btn" 
        @click="reqResend"
        :disabled="isResendDisabled"
      >
        재전송
      </button>
    </div>

    <div class="info_page"> 
      <div class="phone_num">
          {{ $t('인증번호가_발송되었습니다.') }} {{ $t('유효시간') }}
          &nbsp;<span>{{ formattedTime }}</span>
      </div>
      <p>
        {{ $t('인증번호가_전송되지_않은_경우_재전송_버튼을_눌러주세요.') }} 
      </p>
    </div>
  </div>
</template>

<script>
const TOTAL_SECONDS = 300 // 인증번호 유효시간 5분
const COOLDOWN_SECONDS = 60 //재전송 가능 시간 1분 

export default {
  name: 'AuthTimer',
  props: {
    value: {
      type: String,
      default: ''
    },
    targetInfo: {
      type: Object,
      required: false,
      default: function() { return {} }
    }
  },
  data: function() {
    return {
      timerSeconds: TOTAL_SECONDS,
      timerInterval: null
    }
  },
  computed: {
    formattedTime: function() {
      const minutes = Math.floor(this.timerSeconds / 60)
      const seconds = this.timerSeconds % 60

      if (this.timerSeconds <= 0) {
        return this.$t('만료')
      }
      return `${minutes}:${seconds.toString().padStart(2, '0')}`
    },
    isTimerExpired: function() {
      return this.timerSeconds <= 0
    },  
    isResendDisabled: function() {
      return (this.timerSeconds > TOTAL_SECONDS - COOLDOWN_SECONDS)
    },
  },
  mounted: function() {
    this.startTimer()
    
    if (this.$refs.authInput) {
      this.$refs.authInput.focus()
    }
  },
  beforeDestroy: function() {
    this.clearTimer()
  },
  methods: {
    onInput: function(event) {
      if (!event?.target) return

      const val = event.target.value.replace(/[^0-9]/g, '')
      if (val !== event.target.value) {
        event.target.value = val
      }
      this.$emit('input', val)
    },

    reqResend: function() {
      if (this.isResendDisabled) return
      
      this.$emit('resend')
      this.startTimer()
    },

    startTimer: function() {
      this.clearTimer()
      this.timerSeconds = TOTAL_SECONDS
      
      this.timerInterval = setInterval(() => {
        if (this.timerSeconds <= 0) {
          this.clearTimer()
          this.$refs.authInput.value = ''
          this.$refs.authInput.innerHTML=''
          this.$emit('input', "")
          this.$refs.authInput.blur() // 타이머 만료 시 입력창 포커스 해제
          return
        }
        this.timerSeconds--
      }, 1000)
    },

    clearTimer: function() {
      if (!this.timerInterval) return
      
      clearInterval(this.timerInterval)
      this.timerInterval = null
    }
  }
}
</script>

<style scoped>
.input_btn {
  display: flex;
  position: relative;
  align-items: center;
}
.auth-input {
  width: 100%;
}
.btn {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  padding:4px 8px;
  border: 1px solid;
  border-radius: 16px;
  background: #006769;
  color: #eee;
  cursor: pointer;
  font-size: 14px;
}

button.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>